module.exports = __webpack_public_path__ + "img/donate.b2f79558.svg";